import React from 'react';
import { connect } from 'react-redux';
import { ExternalLink } from '../../components';
import Modal from '../../components/Modal/Modal';
import { manageDisableScrolling } from '../../ducks/UI.duck';
import css from './EditListingPhotosForm.css';

const PhotosModal = props => {
  const { isModalOpen, changeModalVisiblity, onManageDisableScrolling } = props;
  // const [submitDisabled, setSubmitDisabled] = useState(true);

  return (
    <div className={css.modalContainer}>
      <Modal
        isOpen={isModalOpen}
        closeButtonMessage=" "
        onClose={() => {
          changeModalVisiblity(false);
        }}
        containerClassName={css.containerContent}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <div>
          <h3 className={css.modalTitle}>Sample Photos</h3>
          {/* <p className={css.linkTitle}>3 Quarters View *</p> */}
          <div className={css.sampleLink}>
            <img
              className={css.sampleImage}
              src={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1602.jpg'
              }
            />
            <ExternalLink
              href={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1602.jpg'
              }
              className={css.link}
            ></ExternalLink>
          </div>
          {/* <p className={css.linkTitle}>Front View *</p> */}
          <div className={css.sampleLink}>
            <img
              className={css.sampleImage}
              src={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1617.jpg'
              }
            />
            <ExternalLink
              href={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1617.jpg'
              }
              className={css.link}
            ></ExternalLink>
          </div>
          {/* <p className={css.linkTitle}>Side View *</p> */}
          <div className={css.sampleLink}>
            <img
              className={css.sampleImage}
              src={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1623.jpg'
              }
            />
            <ExternalLink
              href={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1623.jpg'
              }
              className={css.link}
            ></ExternalLink>
          </div>
          {/* <p className={css.linkTitle}>Side View *</p> */}
          <div className={css.sampleLink}>
            <img
              className={css.sampleImage}
              src={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1631.jpg'
              }
            />
            <ExternalLink
              href={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1631.jpg'
              }
              className={css.link}
            ></ExternalLink>
          </div>
          {/* <p className={css.linkTitle}>Side View *</p> */}
          <div className={css.sampleLink}>
            <img
              className={css.sampleImage}
              src={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1634.jpg'
              }
            />
            <ExternalLink
              href={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1634.jpg'
              }
              className={css.link}
            ></ExternalLink>
          </div>
          {/* <p className={css.linkTitle}>Side View *</p> */}
          <div className={css.sampleLink}>
            <img
              className={css.sampleImage}
              src={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1639.jpg'
              }
            />
            <ExternalLink
              href={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1639.jpg'
              }
              className={css.link}
            ></ExternalLink>
          </div>

          {/* <p className={css.linkTitle}>Side View *</p> */}
          <div className={css.sampleLink}>
            <img
              className={css.sampleImage}
              src={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1642.jpg'
              }
            />
            <ExternalLink
              href={
                'https://drivelah-public-files.s3.ap-southeast-1.amazonaws.com/Images/Sample+Car+Photos/522A1642.jpg'
              }
              className={css.link}
            ></ExternalLink>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

export default connect(null, mapDispatchToProps)(PhotosModal);
